import { useEffect } from 'react';
import { addLoginHandlers } from 'dibs-buyer-layout/exports/loginHandlers';
import { AuthResponseType } from 'dibs-buyer-layout/exports/authTypes';
import { useAppDispatch } from '../reducers/root';
import { transactionBuyerChangedAction } from '../actions/commonActions';

export const useAuthSync = (): void => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        addLoginHandlers(({ userId }: AuthResponseType) => {
            dispatch(
                transactionBuyerChangedAction({
                    buyerId: userId,
                })
            );
        });
    }, [dispatch]);
};
